module.exports = {
  organizer: '主办方',
  home: '首页',
  meeting: '会议',
  agenda: '议程',
  sponsorship_exhibitions: '赞助与展览',
  why_sponsor: '为何赞助',
  sponsorship_consulting: '赞助咨询',
  why_sponsor_text1: 'iTall是长期专注于中国及亚太区域科技发展与创新的高端商务社交品牌，通过系列峰会与展览，持续影响并赋能包括消费、医药、制造、金融等行业在内的众多机构，深度连接产业链中下游，用科技重塑业务流程、提升业务运转效率，驱动企业长远发展。',
  why_sponsor_text2: '我们以切实项目供需、实时案例分析、精准决策沟通、实质项目合作推进为核心，以时下热门丰富主题为牵引，嵌入行业重点领域和关键环节，赋能机构及其决策团队，推动产业技术变革和优化升级。',
  sponsors_exhibitors: '赞助与展商',
  awards: '奖项',
  enroll: '报名',
  conference_pass: '会议通票',
  early_bird_tickets: '特惠早鸟票',
  free_tickets: '免费门票',
  CSTIS: '中国科创峰会',
  CSTIS_text: '抢占科创最高点',
  learn_more: '了解更多',
  num1: '参会代表',
  num2: '赞助商与展商',
  num3: '演讲嘉宾',
  num4: '时段',
  num5: '专场',
  itall: 'iTall科创',
  itall_text1: '数智化浪潮下，科技创新成为新一轮产业变革的核心驱动力，新技术正不断拓宽产业边界，加速产业升级转型。11月23日，会誉集团将于上海召开iTall中国科创峰会，本届峰会将围绕金融科技、智能制造、未来医药三个专场，共商加速推进行业数字化转型的方法，变局之下寻破局之路。',
  itall_text2: '我们以实时案例分析、切实项目供需、精准决策沟通、实质合作推进为核心，以时下热门丰富主题为牵引，嵌入行业重点领域和关键环节，赋能机构及其决策团队，推动产业技术变革和优化升级。',
  guest_speakers: '演讲嘉宾',
  guest_speakers_text: '往届部分演讲嘉宾，排名不分先后',
  guest_speakers_text2: '本届演讲嘉宾，排名不分先后',
  guest1: '胡伟',
  guest1_text1: '信息规划部助理总经理',
  guest1_text2: '泰康养老保险有限公司',
  guest2: '林建',
  guest2_text1: '数通副总裁/金融事业部总经理',
  guest2_text2: '科华数据',
  guest3: '钭旭杰',
  guest3_text1: '战略发展部/中国再保险研究院副总经理',
  guest3_text2: '中再集团',
  guest4: '蔡建宏',
  guest4_text1: '大中华区领导',
  guest4_text2: 'RNA ANALYTICS',
  guest5: '姚凯',
  guest5_text1: '运营总监',
  guest5_text2: '弘康人寿',
  guest6: '郭少伟',
  guest6_text1: '总精算师、首席风险官',
  guest6_text2: '汇友财产相互保险社',
  guest7: '陈婧',
  guest7_text1: '信息技术部总经理',
  guest7_text2: '三井住友海上火灾保险',
  guest8: '张宁',
  guest8_text1: '博士生导师、教授',
  guest8_text2: '金融科技专业负责人、中央财经大学金融学院',
  guest9: '鹿淑煜',
  guest9_text1: '技术支撑中心总经理',
  guest9_text2: '三未信安科技股份有限公司',
  guest10: '王珂',
  guest10_text1: '市场总监',
  guest10_text2: '三未信安科技股份有限公司',
  guest11: '方超',
  guest11_text1: '副总经理',
  guest11_text2: '爱心人寿保险',
  guest12: '陈秋伊',
  guest12_text1: '运营专家',
  guest12_text2: '信泰人寿',
  guest13: '张树国',
  guest13_text1: 'CIO',
  guest13_text2: '中煤财产保险',
  guest14: '张杰',
  guest14_text1: '数据部门总经理',
  guest14_text2: '现代财险',
  guest15: '任启',
  guest15_text1: '高级副总裁',
  guest15_text2: '麒麟信安',
  guest16: '崔楠',
  guest16_text1: '大中华区执行总监',
  guest16_text2: '弗若斯特沙利文',
  guest17: '白雪峰',
  guest17_text1: 'CTO',
  guest17_text2: '盛宝金融科技有限公司',
  guest18: '陈卫丽',
  guest18_text1: '开放银行部场景生态部总经理',
  guest18_text2: '中原银行',
  guest19: '邹琪',
  guest19_text1: '创新金融部总经理',
  guest19_text2: '辽宁振兴银行',
  guest20: '张恒',
  guest20_text1: '解决方案总监',
  guest20_text2: '网宿科技',
  guest21: '王卫',
  guest21_text1: '金融服务总经理',
  guest21_text2: '世纪互联',
  guest22: '林涛',
  guest22_text1: '创始人&CEO',
  guest22_text2: '估图数科',
  guest23: '杨剑飞',
  guest23_text1: '北京软件开发中心副总经理',
  guest23_text2: '蓝海银行',
  guest24: '陈嗣奇',
  guest24_text1: '环球支付方案部工商',
  guest24_text2: '金融销售总监、汇丰银行',
  guest25: '赵国豪',
  guest25_text1: '金融服务解决方案副总裁',
  guest25_text2: '小雨点数科',
  guest26: '张旭峰',
  guest26_text1: '数字金融部总经理',
  guest26_text2: '浙江稠州商业银行',
  guest27: '卢元',
  guest27_text1: '常务副总裁',
  guest27_text2: '数衍集团',
  guest28: '林永峰',
  guest28_text1: '山证科技总经理',
  guest28_text2: '山西证券',
  guest29: '王健辉',
  guest29_text1: '研究总监、投资经理',
  guest29_text2: '东兴证券股份有限公司、资产管理业务总部',
  guest30: '杨涛',
  guest30_text1: '联合创始人&CEO',
  guest30_text2: '凡泰极客',
  guest31: '彭军',
  guest31_text1: '副总裁',
  guest31_text2: '博浩数据服务有限公司',
  guest32: '许卓晗',
  guest32_text1: '高级客户经理',
  guest32_text2: '北京永洪商智科技有限公司',
  guest33: '莫左',
  guest33_text1: '副总裁',
  guest33_text2: '北京商越网络科技有限公司',
  guest34: '唐志勇',
  guest34_text1: '总裁、首席咨询师',
  guest34_text2: '蓝云软件',
  sponsors: "赞助商",
  title1: '演讲赞助商',
  title2: '协作赞助商',
  title3: '展商赞助商',
  sponsors_text: '往届部分赞助商，排名不分先后',
  conference_highlights: '会议亮点',
  participating_businesses: '参与企业',
  institution: '机构',
  trust_in_us: '对我们的信任',
  footer1: '赞助与展览',
  footer2: '演讲与免费参会',
  time: '工作时间',
  why_talk: '邀您登台',
  why_talk_text: 'iTall中国科创系列峰会真诚欢迎行业科技领域专家以主题演讲嘉宾、圆桌讨论嘉宾或大会主持人身份加入。如果您有意向加入该高端科技社交圈，请填写以下申请表，具体以 iTall 组委会审核结果为准，审核一般在一到两个工作日内。',
  request: '申请演讲',
  speech_item1: '闭门案例分析展示',
  speech_item2: '合作伙伴吸引互动',
  speech_item3: '辐射带动能力提升',
  speech_item4: '拓展高层人脉',
  speech_item5: '加速战略部署',
  speech_item6: '完善市场布局',
  day1: '2023年7月27日 第一天',
  day1_1: '国产化',
  day1_2: '开幕致辞',
  day1_3: '顺应数字经济政策导向，国产化替代踏浪而至',
  day1_4: '主题演讲：乘势而行，加速银行ESG和绿色金融转型实践',
  day1_5: '主题演讲：以科创服务为先手，创闭环服务新模式',
  day1_6: '上午茶歇、展台参观技术秀、互动交流',
  day1_7: '主题演讲：CBDC ，一种超越银行整合的支付',
  day1_8: '主题演讲：银行如何通过数字化、线上化服务模式发挥优势，践行绿色可持续发展',
  day1_9: '头脑风暴：数智引领，共话金融科创发展新格局',
  day1_10: '午餐时间',
  day1_11: '国际化',
  day1_12: '主题演讲：数字驱动，打造传统银行与虚拟银行的共赢发展之路',
  day1_13: '主题演讲：金融机构如何推动元宇宙在场景金融中的应用',
  day1_14: '主题演讲：如何通过开发强大的无缝数据生态系统创造竞争优势',
  day1_15: '赞助商机会',
  day1_16: '主题演讲：AI斯坦？人类的下一个爱因斯坦',
  day1_17: '赞助商机会',
  day1_18: '下午茶歇、互动交流',
  day1_19: '技术秀',
  day1_20: '圆桌讨论',
  day1_21: '闭幕',
  day2: '2023年7月28日 第二天',
  day2_1: '银行力',
  day2_2: '开幕致辞',
  day2_3: '探索数字运营变革，引领银行高质量发展',
  day2_4: '商业银行数字化转型的难点与策略',
  day2_5: '赞助商机会',
  day2_6: '上午茶歇、展台参观技术秀、互动交流',
  day2_7: '保险力',
  day2_8: '主题演讲：数字化保险的智能风控与业务融合迸发更大效益',
  day2_9: '漫谈保险业会计准则和监管规则对中国保险市场未来的影响',
  day2_10: '主题演讲（RNA Analytics已预定）',
  day2_11: '头脑风暴：保险行业即将迎来变革，财务风险管理及精算工作的未来方向？',
  day2_12: '午餐时间',
  day2_13: '金融实践力',
  day2_14: '主题演讲：稳固数字化转型安全底座——推进零信任落地',
  day2_15: '主题演讲：建设数字化运营服务体系的路径和方法',
  day2_16: '主题演讲：分布式数据库强势崛起，国内中小型金融机构该如何抉择？',
  day2_17: '赞助商机会',
  day2_18: '主题演讲：云赋能带动应用层面的产品形态、产业业态和商业模式创新',
  day2_19: '赞助商机会',
  day2_20: '下午茶歇、互动交流',
  day2_21: '金融创新力',
  day2_22: '技术秀',
  day2_23: '圆桌讨论：构建可信、安全、稳定的金融科技新局面',
  day2_24: '会议闭幕',
  rights: 'iTall赞助权益包括：',
  rights1: '闭门高层会议',
  rights2: '闭门项目交流',
  rights3: '主题演讲分享',
  rights4: '圆桌讨论',
  rights5: '大会全方位宣传推广',
  rights6: '意向客户定向邀请',
  rights7: '一对一商务引荐',
  will_get: '您将获得',
  get1: '推广新技术、新案例',
  get2: '吸引新客户、新合作',
  get3: '提高品牌知名度、影响力',
  get4: '拓展潜在客户高层人脉',
  get5: '加速市场拓展与客户转化',
  get6: '巩固行业地位与市场份额',
  include: '赞助机会包括:',
  include1: '高层闭门',
  include2: '主题演讲',
  include3: '圆桌讨论',
  include4: '展台展示',
  include5: '技术秀',
  include6: '广告宣传',
  sponsors1: '小雨点于2007年在深圳成立，是国内大数据分析与应用领域的先驱者。小雨点秉承“发现数据真理，释放数据生命力”的愿景，通过对大数据、人工智能、区块链等先进科技的应研究，将现实问题转化为数学应用问题，打造了行业级大数据应用系统，可为企业提供涵盖决策策略、智能管理、智能分析、风险控制等全流程解决方案。经过十余年发展，小雨点已服务过国内外商业银行、保险、券、消金等金融机构，以及电信、零售、物流、医疗等多个行业的头部企业。',
  sponsors2: '起步于2019年，估图数科专注于普惠金融、供应链金融、绿色金融方向，围绕风控、营销场景，为金融机构提供面向中小微企业客群的SaaS产品、API服务及业务核心系统。目标成为金融机构合规、可信、高效的科技合作伙伴。目前已经形成Smart。',
  sponsors3: '商越科技是面向大中型企业提供采购数字化全景解决方案的智能公司，通过商越的智能采购中台、SaaS应用及运营服务帮助每个客户搭建专属的采购互联网平台，让企业采购全程在线化、数字化、智能化，提升效率、降低成本。',
  sponsors4: '湖南麒麟信安科技股份有限公司（股票代码：688152）是国家发改委批复的高可信操作系统国家地方联合工程研究中心的依托实体，入选国家级“专精特新”小巨人企业、国家规划布局内重点软件企业，致力于推进国产化安全应用。',
  sponsors5: '合合信息是一家人工智能及大数据科技企业，基于自主研发的领先的智能文字识别及商业大数据核心技术，为全球C端用户和多元行业B端客户提供数字化、智能化的产品及服务公司C端业务主要为面向全球个人用户的APP产品，包括扫描全能王（智能扫描及文字识别APP）、名片全能王（智能名片及人脉管理APP）、启信宝（企业商业信息查询APP）3款核心产品；公司B端业务为面向企业客户提供以智能文字识别、商业大数据为核心的服务形成了包括基础技术服务、标准化服务和场景化解决方案的业务矩阵，满足客户降本增效、风险管理、智能营销等多元需求，助力客户实现数字化与智能化的转型升级。凭借领先的自主研发技术、成熟的产品落地能力、优质的用户体验及服务质量，公司的C端产品覆盖全球百余个国家和地区的亿级用户，B端服务覆盖了近30个行业的企业客户。在B端业务方面，公司智能文字识别与商业大数据服务已覆盖了银行、证券、保险、政府、物流、制造、地产、零售等近30个行业的众多头部客户，《财富》杂志2020年发布的世界500强公司单中，公司客户已覆盖超过80家。',
  sponsors6: '广州思迈特软件有限公司（简称：思迈特软件）成立于2011年，致力于为企业客户提供一站式商业智能解决方案，以提升和挖掘企业客户的数据价值为使命，专注于商业智能(B)与大数据分析软件产品与服务。公心产品“Smartbi”是一站式大数据分析平台，已经过多年的持续发展，整合了各行业的数据分析和决策支持的功求。满足最终用户在企业级报表、数据可视化分析、自助探索分析、数据挖掘建模、A!智能分析等大数据分析需求。同时作为纯国产的商业智能与大数据分析产品，Smartbi在保持对国际同级别产品竞争力的基础上，针对国内用户普遍的本土性需求有更好的设计弹性和适应性。',
  person: '位',
  price: "10月30日恢复6800/位",
  ticket1: '免费参会',
  ticket2: '0元/位',
  ticket3: '免费报名',
  ticket4: '限10月30日截至',
  ticket5: '1天会议',
  ticket6: '技术秀参观',
  ticket7: '展区参观',
  ticket8: '茶歇交流',
  ticket9: '免费注册与签到通道',
  ticket10: '电子会议会刊',
  ticket11: '五星自助午宴',
  ticket12: '同声传译',
  ticket13: '根据大会实际情况安排',
  ticket14: '会后全套可公布PPT',
  ticket15: '一对一商务引荐',
  ticket16: '高层闭门交流',
  ticket17: 'SVIP专属交流群',
  ticket18: '会后引荐',
  ticket2_1: 'VIP参会代表',
  ticket2_2: '0元/位(仅限金融/医药/制造/甲方业务决策层)',
  ticket2_3: '3,000元/位',
  ticket2_4: '即刻注册',
  ticket2_5: '10月30日恢复原价',
  ticket2_6: '1天会议',
  ticket2_7: '3个专场自由进出',
  ticket2_8: '展区参观',
  ticket2_9: '茶歇交流',
  ticket2_10: '专属注册与签到通道',
  ticket2_11: '纸质会议会刊',
  ticket2_12: '茶歇糕点',
  ticket2_13: '专属会议胸卡',
  ticket2_14: '专属席卡与坐席',
  ticket2_15: '五星自主午宴',
  ticket2_16: '同声传译',
  ticket2_17: '会后全套可公布PPT',
  ticket2_18: '一对一商务引荐',
  ticket2_19: '高层闭门交流',
  ticket2_20: 'SVIP专属交流群',
  ticket2_21: '会后引荐',
  ticket3_1: 'SVIP参会嘉宾',
  ticket3_2: '3,000元/位',
  ticket3_3: '6,800元/位',
  ticket3_4: '即刻注册',
  ticket3_5: '10月30日恢复原价',
  ticket3_6: '2天会议',
  ticket3_7: '展区参观',
  ticket3_8: '茶歇交流',
  ticket3_9: '专属注册与签到通道',
  ticket3_10: '纸质会议会刊',
  ticket3_11: '茶歇糕点',
  ticket3_12: '专属会议胸卡',
  ticket3_13: '专属席卡与坐席',
  ticket3_14: '专属会议胸卡',
  ticket3_15: '五行自助午宴',
  ticket3_16: '同声传译',
  ticket3_17: '会后全套可公布PPT',
  ticket3_18: '根据大会实际情况安排',
  ticket3_19: '一对一商务引荐',
  ticket3_20: '高层闭门交流',
  ticket3_21: 'SVIP专属交流群',
  ticket3_22: '会后引荐',
  expired: '已截止',
  guestnow1_1: '常亮',
  guestnow1_2: '科技创新部总经理',
  guestnow1_3: '信泰保险',
  guestnow2_1: '徐倩',
  guestnow2_2: '事业开发部经理',
  guestnow2_3: '东京海上日动火灾保险（中国）有限公司',
  guestnow3_1: '高蕊',
  guestnow3_2: '软件开发中心测试板块板主',
  guestnow3_3: '中信银行',
  guestnow4_1: '许一览',
  guestnow4_2: '金融市场部总经理',
  guestnow4_3: '华宝都鼎（上海）融资租赁有限公司',
  guestnow5_1: '蒋旭峰',
  guestnow5_2: '零售金融部总经理',
  guestnow5_3: '永丰银行',
  guestnow6_1: '李峰',
  guestnow6_2: '金融科技研究院负责人',
  guestnow6_3: '兴业银行',
  guestnow7_1: '王英杰',
  guestnow7_2: '数据库部门总监',
  guestnow7_3: '陆金所控股',
  guestnow8_1: '杨晓骋',
  guestnow8_2: '合伙人',
  guestnow8_3: '弗若斯特沙利文',
  guestnow9_1: '尚振阳',
  guestnow9_2: '数智转型办公室总经理',
  guestnow9_3: '中原银行',
  guestnow10_1: '王海平',
  guestnow10_2: '副总经理',
  guestnow10_3: '信达期货',
  guestnow11_1: '王明红',
  guestnow11_2: '信息技术部FICC业务研发线条总监',
  guestnow11_3: '华西证券',
  guestnow12_1: '王群航',
  guestnow12_2: '董事，副总经理',
  guestnow12_3: '百嘉基金',
  guestnow13_1: '阳光',
  guestnow13_2: '首席信息官兼首席市场官',
  guestnow13_3: '中航安盟',
  guestnow14_1: '赵岩',
  guestnow14_2: '副总经理',
  guestnow14_3: '国华人寿',
}